import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/TaskTable";
import TaskDrawer from "../components/TaskDrawer";
import { useData } from "../lib/DataContext";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { PriorityBadge, fmtDate } from "../lib/ui";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function Approvals() {
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);
  const { userName } = useData();
  const { user } = useAuth();
  const canApprove = ["master_admin", "admin", "manager"].includes(user?.role);
  const load = () => api.get("/approvals/queue").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const act = async (tid, action) => {
    try {
      await api.post(`/tasks/${tid}/approvals`, { action });
      toast.success(`Task ${action}d`); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-6">
      <PageHeader title="Approvals" subtitle={`${items.length} tasks awaiting review/approval`} />
      <div className="space-y-2">
        {items.length === 0 && <div className="text-center py-12 text-slate-400 text-sm">No pending approvals.</div>}
        {items.map((t) => (
          <div key={t.id} className="bg-white border rounded-lg p-4 flex items-center gap-3" data-testid={`approval-row-${t.human_id}`}>
            <div className="h-9 w-9 rounded-lg bg-blue-100 flex items-center justify-center"><ShieldCheck size={16} className="text-blue-600" /></div>
            <button onClick={() => setOpenId(t.id)} className="flex-1 text-left">
              <div className="flex items-center gap-2"><span className="font-mono text-[10px] text-slate-400">{t.human_id}</span><PriorityBadge value={t.priority} /><span className="text-xs text-slate-500">{t.review_status}</span></div>
              <div className="font-medium text-slate-800">{t.title}</div>
              <div className="text-xs text-slate-500">Owner: {userName(t.primary_owner_id)} · Due {fmtDate(t.current_due_date)}</div>
            </button>
            {canApprove && (
              <div className="flex gap-1.5">
                <Button size="sm" onClick={() => act(t.id, "approve")} data-testid={`approve-${t.human_id}`} className="bg-emerald-600 hover:bg-emerald-700">Approve</Button>
                <Button size="sm" variant="outline" onClick={() => act(t.id, "return")}>Return</Button>
                <Button size="sm" variant="destructive" onClick={() => act(t.id, "reject")}>Reject</Button>
              </div>
            )}
          </div>
        ))}
      </div>
      {openId && <TaskDrawer taskId={openId} onClose={() => setOpenId(null)} onChanged={load} />}
    </div>
  );
}
